import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AccountPopupField, AccountPopupSaveFooter } from "./accountPopupFields";

const ContactPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const displayValues = {
    mobileNumber: values.mobileNumber || "",
    phoneNumber: values.phoneNumber || "",
    businessEmail: values.businessEmail || "",
    website: values.website || "",
    googleBusinessProfile: values.googleBusinessProfile || "",
  };

  const steps = [
    {
      title: "Mobile Number",
      field: "mobileNumber",
      placeholder: "+61 412 345 678",
      inputType: "tel",
    },
    {
      title: "Landline Number",
      field: "phoneNumber",
      placeholder: "+61 2 9876 5432",
      inputType: "tel",
    },
    {
      title: "Business Email",
      field: "businessEmail",
      placeholder: "contact@yourbusiness.com.au",
      inputType: "email",
    },
    {
      title: "Business Website",
      field: "website",
      placeholder: "www.yourbusiness.com.au",
      inputType: "url",
    },
    {
      title: "Google business profile",
      field: "googleBusinessProfile",
      placeholder: "https://business.google.com/your-business",
      inputType: "url",
    },
  ];

  const currentStepData = steps[currentStep];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) => (
                  <AccountPopupField
                    step={currentStepData}
                    fieldKey={currentStepData.field}
                    value={displayValues[currentStepData.field]}
                    onChange={(v) => setFieldValue(currentStepData.field, v)}
                    form={form}
                  />
                )}
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default ContactPopup;
